// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "b2ec16c8dc2f3147fdc6" + ".chunk.js";
};